<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <Concepts/>
    </v-container>
  </div>
</template>
<script>
import Concepts from '../../components/Definiciones/ConceptosDeSueldos/salaryConcepts.vue';
import LandingToolbar from "@/components/LandingToolbar/LandingToolbar.vue";
    
    export default {
    components: { LandingToolbar, Concepts },
    };
</script>
    